import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  CircularProgress,
  IconButton,
  Box,
  Collapse,
  Typography,
} from "@mui/material";
import { Edit, Delete, ExpandMore, ExpandLess } from "@mui/icons-material";
import checkImg from "../../Components/Assets/images/checkimg.jpg";
import wrongImg from "../../Components/Assets/images/wrongimg.jpg";
import Swal from "sweetalert2";
import configServ from "../../services/config"; // Replace with your actual service
import LoaderNew from "../../Components/Loader/LoaderNew";

const MenuTable = ({ handleEditData, menuList, loading, fetchMenuList }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expandedRows, setExpandedRows] = useState({}); // To track expanded rows
  const headers = [
    "NAME",
    "ROUTES",
    "ICON",
    "permission",
    "ACTIVE",
    "ADMIN",
    "Customer",
    "Primary Menu",
    "Order ID",
    "ACTION",
    "",
  ];

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRowExpand = (id) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Toggle expand/collapse for the row
    }));
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const res = await configServ.menuDelete({ id: id });
        if (res.status === 200) {
          Swal.fire("Deleted!", "Your menu item has been deleted.", "success");
          fetchMenuList(); // Refresh the list
        } else {
          Swal.fire("Error!", "Failed to delete the menu item.", "error");
        }
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Error!",
          "An error occurred while deleting the menu item.",
          "error"
        );
      }
    }
  };

  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#4CB5F5",
    color: "white",
    textAlign: "center",
    py: 1,
  };

  const submenuHeaderStyle = {
    fontSize: 12,
    fontWeight: "bold",
    backgroundColor: "#D6E8F7",
    color: "#333",
    textAlign: "center",
    py: 1,
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll for better UX
    });
  };

  return (
    <Box
      sx={{
        marginTop: 2,
        animation: "fadeIn 0.8s ease",
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "translateY(20px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {/* Mobile Layout */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          width: "100%", // Use 100% instead of 100vw to respect container boundaries
          ml: 0,
          mr: 0,
          overflowX: "hidden", // Prevent horizontal overflow
        }}
      >
        {menuList.map((row, index) => (
          <Box
            key={row.id}
            sx={{
              mb: 2,
              p: 2,
              border: "1px solid",
              borderColor: "grey.300",
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <strong>
                  {index + 1}. {row.name}
                </strong>
                <Box>Routes: {row.routes}</Box>
                <Box>Icon: {row.icon}</Box>
                <Box>
                  permission:{" "}
                  <img
                    src={row.permission ? checkImg : wrongImg}
                    alt={row.permission ? "Active" : "Inactive"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
                <Box>
                  Active:{" "}
                  <img
                    src={row.is_active ? checkImg : wrongImg}
                    alt={row.is_active ? "Active" : "Inactive"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
                <Box>
                  Admin:{" "}
                  <img
                    src={row.is_admin ? checkImg : wrongImg}
                    alt={row.is_admin ? "Admin" : "Not Admin"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
                <Box>
                  Customer:{" "}
                  <img
                    src={row.is_customer ? checkImg : wrongImg}
                    alt={row.is_customer ? "customer" : "Not Customer"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
                <Box>
                  Primary Menu:{" "}
                  <img
                    src={row.is_primary ? checkImg : wrongImg}
                    alt={row.is_primary ? "Primary Menu" : "Not Primary Menu"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </Box>
                <Box>Order ID: {row.order_id || "N/A"} </Box>
              </Box>
              <Box>
                <IconButton
                  title="Edit"
                  onClick={() => {
                    scrollToTop(); // Scroll to top
                    handleEditData(row);
                  }}
                  style={{ color: "blue" }}
                >
                  <Edit />
                </IconButton>
                {/* <IconButton
                  title="Delete"
                  onClick={() => handleDelete(row.id)}
                  style={{ color: "red" }}
                >
                  <Delete />
                </IconButton> */}
                {row.submenus && row.submenus.length > 0 && (
                  <IconButton
                    onClick={() => handleRowExpand(row.id)}
                    style={{ color: "green" }}
                    title="Expand/Collapse"
                  >
                    {expandedRows[row.id] ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                )}
              </Box>
            </Box>
            {row.submenus &&
              row.submenus.length > 0 &&
              expandedRows[row.id] && (
                <Box sx={{ mt: 2, pl: 2 }}>
                  {row.submenus.map((submenu, submenuIndex) => (
                    <Box
                      key={submenu.id}
                      sx={{
                        mb: 1,
                        p: 1,
                        border: "1px solid",
                        borderColor: "grey.200",
                        borderRadius: "4px",
                      }}
                    >
                      <strong>
                        {submenuIndex + 1}. {submenu.name}
                      </strong>
                      <Box>Routes: {submenu.routes}</Box>
                      <Box>Icon: {submenu.icon}</Box>
                      <Box>
                        permission:{" "}
                        <img
                          src={submenu.permission ? checkImg : wrongImg}
                          alt={submenu.permission ? "Active" : "Inactive"}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Box>
                      <Box>
                        Active:{" "}
                        <img
                          src={submenu.is_active ? checkImg : wrongImg}
                          alt={submenu.is_active ? "Active" : "Inactive"}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Box>
                      <Box>
                        Admin:{" "}
                        <img
                          src={submenu.is_admin ? checkImg : wrongImg}
                          alt={submenu.is_admin ? "Admin" : "Not Admin"}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Box>
                      <Box>
                        Customer:{" "}
                        <img
                          src={submenu.is_customer ? checkImg : wrongImg}
                          alt={
                            submenu.is_customer
                              ? "is_customer"
                              : "Not is_customer"
                          }
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Box>
                      <Box>Order ID: {submenu.sub_order_id || "N/A"} </Box>
                    </Box>
                  ))}
                </Box>
              )}
          </Box>
        ))}
      </Box>

      {/* Desktop Layout */}
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Paper elevation={3}>
          <TableContainer>
            <Table sx={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellStyle}>S.No.</TableCell>
                  {headers.map((header, index) => (
                    <TableCell key={index} sx={headerCellStyle}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headers.length}
                      sx={{
                        textAlign: "center",
                        height: 200,
                      }}
                    >
                      <LoaderNew />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {Array.isArray(menuList) && menuList.length > 0 ? (
                    menuList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <React.Fragment key={row.id}>
                          {/* Menu Row */}
                          <TableRow
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "grey.100" : "white",
                            }}
                          >
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {page * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.name}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.routes}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.icon}
                            </TableCell>
                            {/* <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.permission || "N/A"}
                            </TableCell> */}
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={row.permission ? checkImg : wrongImg}
                                  alt={row.permission ? "Active" : "Inactive"}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={row.is_active ? checkImg : wrongImg}
                                  alt={row.is_active ? "Active" : "Inactive"}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={row.is_admin ? checkImg : wrongImg}
                                  alt={row.is_admin ? "Admin" : "Not Admin"}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={row.is_customer ? checkImg : wrongImg}
                                  alt={
                                    row.is_customer
                                      ? "customer"
                                      : "Not Customer"
                                  }
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={row.is_primary ? checkImg : wrongImg}
                                  alt={
                                    row.is_primary
                                      ? "Primary Menu"
                                      : "Not Primary Menu"
                                  }
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.order_id || "N/A"}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              <IconButton
                                title="Edit"
                                onClick={() => {
                                  scrollToTop(); // Scroll to top
                                  handleEditData(row);
                                }}
                                style={{ color: "blue" }}
                              >
                                <Edit />
                              </IconButton>
                              {/* <IconButton
                                title="Delete"
                                onClick={() => handleDelete(row.id)}
                                style={{ color: "red" }}
                              >
                                <Delete />
                              </IconButton> */}
                            </TableCell>
                            <TableCell
                              sx={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              {row.submenus && row.submenus.length > 0 && (
                                <IconButton
                                  onClick={() => handleRowExpand(row.id)}
                                  style={{ color: "green" }}
                                  title="Expand/Collapse"
                                >
                                  {expandedRows[row.id] ? (
                                    <ExpandLess />
                                  ) : (
                                    <ExpandMore />
                                  )}
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>

                          {/* Submenu Rows (Expandable) */}
                          {row.submenus && row.submenus.length > 0 && (
                            <TableRow>
                              <TableCell
                                colSpan={headers.length + 1}
                                sx={{ paddingLeft: 5 }}
                              >
                                <Collapse
                                  in={expandedRows[row.id]}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Table sx={{ width: "100%" }}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={submenuHeaderStyle}>
                                          S.No.
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          NAME
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          ROUTES
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          ICON
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          Permission
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          ACTIVE
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          ADMIN
                                        </TableCell>
                                        <TableCell sx={submenuHeaderStyle}>
                                          CUSTOMER
                                        </TableCell>
                                         <TableCell sx={submenuHeaderStyle}>
                                          Order No.
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {row.submenus.map(
                                        (submenu, submenuIndex) => (
                                          <TableRow
                                            key={submenu.id}
                                            sx={{
                                              backgroundColor:
                                                submenuIndex % 2 === 0
                                                  ? "grey.50"
                                                  : "white",
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {submenuIndex + 1}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              {submenu.name}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              {submenu.routes}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              {submenu.icon}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <img
                                                src={
                                                  submenu.permission
                                                    ? checkImg
                                                    : wrongImg
                                                }
                                                alt={
                                                  submenu.permission
                                                    ? "Active"
                                                    : "Inactive"
                                                }
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <img
                                                src={
                                                  submenu.is_active
                                                    ? checkImg
                                                    : wrongImg
                                                }
                                                alt={
                                                  submenu.is_active
                                                    ? "Active"
                                                    : "Inactive"
                                                }
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <img
                                                src={
                                                  submenu.is_admin
                                                    ? checkImg
                                                    : wrongImg
                                                }
                                                alt={
                                                  submenu.is_admin
                                                    ? "Admin"
                                                    : "Not Admin"
                                                }
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <img
                                                src={
                                                  submenu.is_customer
                                                    ? checkImg
                                                    : wrongImg
                                                }
                                                alt={
                                                  submenu.is_customer
                                                    ? "Customer"
                                                    : "Not Customer"
                                                }
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                textAlign: "center",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {submenu.sub_order_id || "N/A"}
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headers.length}
                        align="center"
                        style={{ color: "red" }}
                      >
                        No data available.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          {!loading && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={menuList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default MenuTable;
